exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blue-btn[data-v-a7d4dde0],.el-button--primary[data-v-a7d4dde0]{background:linear-gradient(90deg, #0E3491 0%, #225BFC 100%)}.td-word-sm[data-v-a7d4dde0]{font-size:.12rem}.status[data-v-a7d4dde0]{width:1.12rem;height:.28rem;display:flex;align-items:center;color:#fff;font-size:.14rem;border-radius:.04rem;line-height:.28rem;white-space:nowrap;cursor:pointer}.status img[data-v-a7d4dde0]{width:.2rem;margin-right:.06rem;margin-left:.1rem}", ""]);

// exports
